import { HEADERS, type Permission, type RoleCode } from '@cqinv/shared';
import { ApiError, apiFetch } from '../../lib/api';

export interface SesionMe {
  readonly user: { readonly id: string; readonly displayName: string; readonly email: string | null };
  readonly company: { readonly id: string; readonly name: string; readonly roleCode: RoleCode } | null;
  readonly permissions: readonly Permission[];
  readonly csrfToken: string;
  readonly platformAdmin?: boolean;
}

export interface EmpresaDeSesion {
  readonly id: string;
  readonly name: string;
  readonly roleCode: string;
}

export async function entrarLocal(email: 'admin@local' | 'operario@local'): Promise<void> {
  await apiFetch('/api/auth/dev-login', {
    method: 'POST',
    body: JSON.stringify({ email }),
  });
}

export function loginUrl(returnTo = window.location.pathname): string {
  const destino = returnTo.startsWith('/') && !returnTo.startsWith('//') ? returnTo : '/';
  return `/api/auth/login?returnTo=${encodeURIComponent(destino)}`;
}

export async function leerSesion(): Promise<SesionMe | null> {
  try {
    return await apiFetch<SesionMe>('/api/session/me');
  } catch (error) {
    if (error instanceof ApiError && error.status === 401) return null;
    throw error;
  }
}

export function listarEmpresas(): Promise<readonly EmpresaDeSesion[]> {
  return apiFetch('/api/session/companies');
}

export function elegirEmpresa(companyId: string, csrfToken: string): Promise<{ readonly companyId: string }> {
  return apiFetch('/api/session/company', {
    method: 'POST',
    headers: { [HEADERS.csrfToken]: csrfToken },
    body: JSON.stringify({ companyId }),
  });
}

export async function cerrarSesion(csrfToken: string): Promise<void> {
  const { redirectTo } = await apiFetch<{ redirectTo: string }>('/api/auth/logout', {
    method: 'POST',
    headers: { [HEADERS.csrfToken]: csrfToken },
  });
  window.location.assign(redirectTo);
}
